import * as StateManager from '../../../store/state/state-manager';
import { listAction } from '../../../store/state/actions/action-creators';
import Utils from '../../../utils/utils';

class Update {
  static execute(
    contextName: string,
    target: string,
    index: string | number,
    payload: object,
    pageReference: string,
    skipStateUpdate: boolean,
    skipDirtyValidation: boolean,
    isDefault: boolean
  ) {
    const actionPayload = {
      instruction: 'UPDATE',
      content: {
        ...Utils.unflatten(payload)
      },
      isDefault
    };
    const instruction = {
      content: { ...actionPayload.content },
      target: Utils.buildInstructionPageReference(pageReference, target),
      [typeof index === 'string' ? 'groupIndex' : 'listIndex']: index,
      instruction: 'UPDATE'
    };
    if (!skipStateUpdate) {
      StateManager.dispatch(
        listAction({
          ...actionPayload,
          [typeof index === 'string' ? 'groupIndex' : 'listIndex']: typeof index === 'string' ? index : index - 1,
          context: contextName,
          referenceList: `${pageReference}${target}`,
          skipDirtyValidation
        })
      );
    }
    return instruction;
  }
}

export default Update;
